import { render, staticRenderFns } from "./ChangePhaseDialog.vue?vue&type=template&id=4a44fbea&"
import script from "./ChangePhaseDialog.vue?vue&type=script&lang=js&"
export * from "./ChangePhaseDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./ChangePhaseDialog.vue?vue&type=custom&index=0&blockType=messages"
if (typeof block0 === 'function') block0(component)

export default component.exports